import { IProductListVM } from '../../models/response/IProductResponse';
const initialProcessState: IProductListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  ProductList: [],
};

export default initialProcessState;
